import React from "react"
import { FiCheck, FiX } from "react-icons/fi"
import { IconButton } from "@chakra-ui/react"

type UserAffiliationConfirmOpProps = {
  isDisabled: boolean
  isLoading: boolean
  onConfirm: (args: any) => void
  onCancel: (args: any) => void
}

export const UserAffiliationConfirmOp: React.FC<UserAffiliationConfirmOpProps> = ({
  isDisabled,
  isLoading,
  onConfirm,
  onCancel,
}) => {
  return (
    <>
      <IconButton
        icon={<FiCheck />}
        variant="solid"
        colorScheme="green"
        aria-label="confirm"
        boxSize="25px"
        minW="25px"
        cursor="pointer"
        p={1}
        m="2.5px"
        isDisabled={isDisabled}
        isLoading={isLoading}
        onClick={onConfirm}
      />
      <IconButton
        icon={<FiX />}
        variant="solid"
        colorScheme="red"
        aria-label="cancel"
        boxSize="25px"
        minW="25px"
        cursor="pointer"
        p={1}
        m="2.5px"
        isDisabled={isDisabled}
        isLoading={isLoading}
        onClick={onCancel}
      />
    </>
  )
}
